const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPredictionFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      background: "#ffffff",
      backgroundColor: "light-dark(#ffffff, var(--ge-dark-color, #121212))",
      colorScheme: "light dark"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "183px",
    height: "206px",
    viewBox: "-0.5 -0.5 183 206",
    content: "<mxfile host=\"Electron\" agent=\"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/28.1.2 Chrome/138.0.7204.243 Electron/37.4.0 Safari/537.36\" version=\"28.1.2\" scale=\"1\" border=\"0\"> <diagram name=\"Page-1\" id=\"qiE9dSh5HyO_8AIsu16J\"> <mxGraphModel dx=\"674\" dy=\"510\" grid=\"1\" gridSize=\"10\" guides=\"1\" tooltips=\"1\" connect=\"1\" arrows=\"1\" fold=\"1\" page=\"1\" pageScale=\"1\" pageWidth=\"24\" pageHeight=\"24\" math=\"0\" shadow=\"0\"> <root> <mxCell id=\"0\" /> <mxCell id=\"1\" parent=\"0\" /> <mxCell id=\"6O_Aa8ODgEkYodissINO-1\" value=\"\" style=\"shape=tape;whiteSpace=wrap;html=1;shadow=1;strokeWidth=4;fillColor=light-dark(#f20707, #ededed);strokeColor=#C73500;fontColor=#000000;gradientColor=#FF8000;gradientDirection=radial;\" vertex=\"1\" parent=\"1\"> <mxGeometry y=\"106\" width=\"120\" height=\"100\" as=\"geometry\" /> </mxCell> <mxCell id=\"6O_Aa8ODgEkYodissINO-2\" value=\"\" style=\"endArrow=none;html=1;rounded=0;exitX=0.5;exitY=0;exitDx=0;exitDy=0;endSize=5;strokeWidth=14;strokeColor=#FFCC33;entryX=0.003;entryY=0.172;entryDx=0;entryDy=0;entryPerimeter=0;\" edge=\"1\" parent=\"1\" source=\"6O_Aa8ODgEkYodissINO-3\" target=\"6O_Aa8ODgEkYodissINO-1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint y=\"270\" as=\"sourcePoint\" /> <mxPoint x=\"-10\" y=\"120\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"6O_Aa8ODgEkYodissINO-3\" value=\"\" style=\"rounded=1;whiteSpace=wrap;html=1;arcSize=23;strokeWidth=2;fillColor=light-dark(#616161,#EDEDED);strokeColor=light-dark(#E6E6E6,#EDEDED);\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"-42\" y=\"274\" width=\"84\" height=\"26\" as=\"geometry\" /> </mxCell> <mxCell id=\"6O_Aa8ODgEkYodissINO-4\" value=\"\" style=\"endArrow=none;html=1;rounded=0;strokeWidth=9;\" edge=\"1\" parent=\"1\"> <mxGeometry width=\"50\" height=\"50\" relative=\"1\" as=\"geometry\"> <mxPoint x=\"-50\" y=\"300\" as=\"sourcePoint\" /> <mxPoint x=\"50\" y=\"300\" as=\"targetPoint\" /> </mxGeometry> </mxCell> <mxCell id=\"6O_Aa8ODgEkYodissINO-5\" value=\"\" style=\"shape=or;whiteSpace=wrap;html=1;rotation=-90;fillColor=#f0a30a;fontColor=#000000;strokeColor=#BD7000;\" vertex=\"1\" parent=\"1\"> <mxGeometry x=\"-6.5\" y=\"102\" width=\"13\" height=\"30\" as=\"geometry\" /> </mxCell> </root> </mxGraphModel> </diagram>\n</mxfile>\n",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "0%",
    id: "drawio-svg-MRYcsw0zP9BiVEhpwRgl-gradient-light-dark_f20707_ededed_-1-_ff8000-1-r-0"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f20707",
    stopOpacity: 1,
    style: {
      stopColor: "light-dark(rgb(242, 7, 7), rgb(237, 237, 237))",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8000",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255, 128, 0)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("rect", {
    fill: "#ffffff",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    style: {
      fill: "light-dark(#ffffff, var(--ge-dark-color, #121212))"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 0
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": 1
  }, /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "6O_Aa8ODgEkYodissINO-1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "drop-shadow(light-dark(rgba(0, 0, 0, 0.25), rgba(237, 237, 237, 0.25)) 2px 3px 2px)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 54 26 Q 84 62 114 26 Q 144 -10 174 26 L 174 86 Q 144 50 114 86 Q 84 122 54 86 L 54 26 Z",
    fill: "url(#drawio-svg-MRYcsw0zP9BiVEhpwRgl-gradient-light-dark_f20707_ededed_-1-_ff8000-1-r-0)",
    stroke: "#c73500",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    pointerEvents: "all",
    style: {
      fill: "url(&quot",
      stroke: "rgb(199, 53, 0)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "6O_Aa8ODgEkYodissINO-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 54 174 L 54.36 23.2",
    fill: "none",
    stroke: "#ffcc33",
    strokeWidth: 14,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "rgb(255, 204, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "6O_Aa8ODgEkYodissINO-3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 174,
    width: 84,
    height: 26,
    rx: 5.98,
    ry: 5.98,
    fill: "#616161",
    stroke: "#e6e6e6",
    strokeWidth: 2,
    pointerEvents: "all",
    style: {
      fill: "light-dark(rgb(97, 97, 97), rgb(237, 237, 237))",
      stroke: "light-dark(rgb(230, 230, 230), rgb(237, 237, 237))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "6O_Aa8ODgEkYodissINO-4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 4 200 L 104 200",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    pointerEvents: "stroke",
    style: {
      stroke: "light-dark(rgb(0, 0, 0), rgb(255, 255, 255))"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-cell-id": "6O_Aa8ODgEkYodissINO-5"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 47.5 2 Q 60.5 2 60.5 17 Q 60.5 32 47.5 32 Z",
    fill: "#f0a30a",
    stroke: "#bd7000",
    strokeMiterlimit: 10,
    transform: "rotate(-90,54,17)",
    pointerEvents: "all",
    style: {
      fill: "rgb(240, 163, 10)",
      stroke: "rgb(189, 112, 0)"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictionFlag);
export default __webpack_public_path__ + "static/media/Prediction Flag.0960a2e9e408db8999717976da668794.svg";
export { ForwardRef as ReactComponent };